import { Component, Input } from '@angular/core';
import { Usuario } from '../../entities/usuario';


//import _ from 'lodash';
import moment from 'moment';

moment.locale('pt-BR');

@Component({
    selector: 'resumao',
    templateUrl: 'resumao.html'
})
export class ResumaoComponent {
    @Input('usuario') usuario: Usuario;

    constructor() { }

}


// WEBPACK FOOTER //
// ./src/components/resumao/resumao.ts